<template>
  <tr class="customer-item" v-if="user" @click="showModal = true" style="cursor: pointer">
    <td>
      <v-avatar size="30">
        <img
          v-if="user.profile_pic"
          @error="onFailLoad"
          :src="user.profile_pic"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
        <img
          v-else
          :src="'/static/img/assets/livechat/profile.png'"
          width="30"
          height="30"
          :alt="user.first_name + ' ' + user.last_name"
        />
      </v-avatar>
    </td>
    <td
      style="min-width: 300px"
      :title="
        (user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : '')
      "
    >
      <div style="display: inline-block; vertical-align: top; margin-top: 5px">
        {{
          ((user.first_name ? user.first_name : '') + ' ' + (user.last_name ? user.last_name : ''))
            | truncate(35)
        }}
      </div>
    </td>
    <td class="text-xs-center">
      <span style="color: #3b5998" v-if="user.app == 'facebook'">
        <i class="fab fa-facebook-square"></i>
      </span>
      <span style="color: #00c300" v-else-if="user.app == 'line'">
        <i class="fab fa-line"></i>
      </span>
      <span style="color: #C13584" v-else-if="user.app == 'instagram'">
        <i class="fab fa-instagram"></i>
      </span>
      <span style="color: #F4B400" v-else-if="user.app == 'google'">
        <i class="fab fa-google"></i>
      </span>
      <span style="color: #00c300; font-size: 17px;" v-else-if="user.app == 'whatsapp'">
        <i class="fab fa-whatsapp"></i>
      </span>
      <span class="primary--text" v-else>
        {{ user.app }}
      </span>
    </td>
    <td>{{ user.gender ? $t(user.gender) : '-' }}</td>
    <td v-if="$store.state.niveapage.includes(selectedBot.pageid)">
      {{ user.usermessages ? $t(user.usermessages) : '-' }}
    </td>

    <td class="text-xs-center">
      {{ user.registertimestamp ? getFormatDate(user.registertimestamp, 'DD/MM/YYYY') : '-' }}
    </td>
    <td class="text-xs-center">
      {{ user.timestamp ? getFormatDate(user.timestamp, 'DD/MM/YYYY') : '-' }}
    </td>
    <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
      <customer-item-value :value="user['email']">{{ user.email }}</customer-item-value>
    </td>
    <td :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }">
      <customer-item-value :value="user['phoneno']">{{ user.phoneno }}</customer-item-value>
    </td>
    <td
      :class="{ 'background-gray': $store.getters.getPackage != 'premium' || isCoachlab }"
      class="text-xs-center"
    >
      <customer-item-value :value="user['status']">{{ user.status }}</customer-item-value>
    </td>
    <!-- <td
      :class="{'background-gray': $store.getters.getPackage != 'premium' || isCoachlab}"
      class="text-xs-center"
    >
      <customer-item-value :value="user['messagesent']">{{user.messagesent | numberFormat}}</customer-item-value>
    </td> -->
    <td class="text-xs-center" style="white-space: nowrap">
      <template v-if="userLocale">
        <flag :iso="userLocale.icon" />
      </template>
      <template v-else>-</template>
    </td>
    <!-- <td class="text-xs-center" v-if="hasAdvanced">
      {{ orderQuantity }}
    </td>
    <td class="text-xs-center" style="white-space: nowrap" v-if="hasAdvanced">
      {{ totalPurchaseAmount }}
    </td>
    <td class="text-xs-center" v-if="hasAdvanced">
      {{ purchaseDate.firstTimePurchase }}
    </td>
    <td class="text-xs-center" v-if="hasAdvanced">
      {{ purchaseDate.latestPurchase }}
    </td> -->
    <td class="text-xs-center" :class="{ 'background-gray': !hasAdvanced }">
      <customer-item-value :value="orderQuantity" :isLocked="!hasAdvanced">
        {{ orderQuantity }}
      </customer-item-value>
    </td>
    <td
      class="text-xs-center"
      style="white-space: nowrap"
      :class="{ 'background-gray': !hasAdvanced }"
    >
      <customer-item-value :value="totalPurchaseAmount" :isLocked="!hasAdvanced">
        {{ totalPurchaseAmount }}
      </customer-item-value>
    </td>
    <td class="text-xs-center" :class="{ 'background-gray': !hasAdvanced }">
      <customer-item-value :value="purchaseDate.firstTimePurchase" :isLocked="!hasAdvanced">
        {{ purchaseDate.firstTimePurchase }}
      </customer-item-value>
    </td>
    <td class="text-xs-center" :class="{ 'background-gray': !hasAdvanced }">
      <customer-item-value :value="purchaseDate.latestPurchase" :isLocked="!hasAdvanced">
        {{ purchaseDate.latestPurchase }}
      </customer-item-value>
    </td>
    <td v-if="isBU">
      <customer-item-value :value="user['lineid']">{{ user.lineid }}</customer-item-value>
    </td>
    <td v-if="isBU">
      <customer-item-value :value="user['province']">{{ user.province }}</customer-item-value>
    </td>
    <td v-if="isBU">
      <customer-item-value :value="user['school']">{{ user.school }}</customer-item-value>
    </td>

    <td>
      <v-btn outline fab small class="extra-small">
        <i class="fas fa-align-left"></i>
      </v-btn>

      <v-dialog v-model="showModal" width="800">
        <v-card>
          <template v-if="$store.state.niveapage.includes(selectedBot.pageid)">
            <nivea-customer-detail v-if="showModal" :key="user.id" v-model="user">
              <div slot="header" class="text-xs-right">
                <v-btn flat fab small class="extra-small" @click="showModal = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </nivea-customer-detail>
          </template>
          <template v-else>
            <customer-detail v-if="showModal" :key="user.id" v-model="user">
              <div slot="header" class="text-xs-right">
                <v-btn flat fab small class="extra-small" @click="showModal = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </div>
            </customer-detail>
          </template>

          <v-card-text class="text-xs-center">
            <v-btn outline color="grey" @click="showModal = false">{{ $t('cancel') }}</v-btn>
          </v-card-text>
        </v-card>
      </v-dialog>

      <!-- <a href="javascript:void(0)" class="btn btn-primary transparent btn-sm" style="margin-right: 5px; margin-bottom: 5px;"><i class="fab fa-facebook-messenger"></i> Chat</a> -->
    </td>
  </tr>
</template>

<script>
import { mapGetters } from 'vuex'
import dayjs from 'dayjs'
import config from '@/config'
import CustomerItemValue from './CustomerItemValue'
import EditCustomerValue from './EditCustomerValue'
import specialtext from '@/components/elements/specialtext'
import Tags from '@/components/elements/Tags'
import api from '@/api'
import CustomerDetail from './CustomerDetail.vue'
import NiveaCustomerDetail from './NiveaCustomerDetail.vue'
export default {
  props: ['value'],
  data: function() {
    return {
      user: undefined,
      showModal: false,
      showAllIntent: false,
      isEditTag: false,
      usertag: ''
    }
  },
  components: {
    CustomerItemValue,
    EditCustomerValue,
    specialtext,
    Tags,
    CustomerDetail,
    NiveaCustomerDetail
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    }),
    isBU() {
      return this.$store.state.pageBU.includes(this.selectedBot.pageid)
    },
    filterIntent: function() {
      var vm = this
      return vm.user.intentlist.sort(function(a, b) {
        if (parseInt(a[1]) > parseInt(b[1])) {
          return -1
        }

        if (parseInt(a[1]) < parseInt(b[1])) {
          return 1
        }

        return 0
      })
    },
    userLocale: function() {
      var vm = this
      return config.locale.find(function(locale) {
        if (vm.user.locale == locale.value) {
          return locale.title
        }
      })
    },
    tags: function() {
      var vm = this
      if (vm.user.tags !== '' && vm.user.tags != null) {
        var usertags = vm.user.tags.split(',')
        return usertags
      } else {
        return []
      }
    },
    usertags: {
      get() {
        let vm = this
        if (vm.user && vm.user.tags && vm.user.tags !== '') {
          var usertags = []

          usertags = vm.user.tags.split(',')
          var result = []
          if (usertags) {
            usertags.map(function(tag, index) {
              result.push({ text: tag })
            })
          }
          return result
        } else {
          return []
        }
      },
      set(value) {
        let vm = this
        var result = []
        if (value) {
          value.map(function(tag, index) {
            result.push(tag.text)
          })
        }
        vm.user.tags = result.join(',')
      }
    },
    orderQuantity() {
      const { event_data } = this.user

      if (event_data && event_data['Purchase']) {
        return Object.values(event_data['Purchase']['currencies']).reduce(
          (prev, curr) => prev + curr['quantity'],
          0
        )
      }

      return '-'
    },
    totalPurchaseAmount() {
      const { event_data } = this.user

      if (event_data && event_data['Purchase']) {
        const numberFormatter = Intl.NumberFormat()

        return Object.entries(event_data['Purchase']['currencies'])
          .filter(([key]) => this.$store.state.currencies.includes(key))
          .map(([key, value]) => {
            return `${numberFormatter.format(value.value)} ${key}`
          })
          .join(', ')
      }

      return '-'
    },
    purchaseDate() {
      const { event_data } = this.user
      const purchaseDate = {
        firstTimePurchase: '-',
        latestPurchase: '-'
      }

      if (event_data && event_data['Purchase']) {
        const firstTimePurchase = dayjs(event_data['Purchase']['created_at'])
        const latestPurchase = dayjs(event_data['Purchase']['last_updated_at'])

        if (firstTimePurchase.isValid()) {
          purchaseDate['firstTimePurchase'] = firstTimePurchase.format('DD/MM/YYYY')
        }
        if (latestPurchase.isValid()) {
          purchaseDate['latestPurchase'] = latestPurchase.format('DD/MM/YYYY')
        }
      }

      return purchaseDate
    },
    hasAdvanced() {
      const packages = this.getPackageType()
      return packages.includes('advanced')
      // return false
    }
  },
  mounted: function() {
    this.user = this.value
    this.cached_tag = this.user.tags
  },
  methods: {
    saveEditTag: function() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.user.id,
        tags: vm.user.tags || ''
      }
      api.saveUserTags(data, function(error, response) {
        if (error) {
          console.error(error)
        }
        vm.cached_tag = vm.user.tags
        vm.isEditTag = false
      })
    },
    cancelEditTag: function() {
      this.user.tags = this.cached_tag
      this.isEditTag = false
    },
    onFailLoad: function() {
      this.$set(this.user, 'profile_pic', '/static/img/assets/livechat/profile.png')
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    },
    addUserTags: function(newTags) {
      this.usertags = newTags
    },
    checkUserTags(obj) {
      this.errorTag = []
      if (obj.tag.text.length > 20) {
        this.errorTag.push('overmaxlength')
        obj.error()
      } else if (obj.tag.isDuplicate) {
        this.errorTag.push('duplicate')
        obj.error()
      } else obj.addTag()
    },
    onEditStatus: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        status: payload.customer_value || ''
      }
      api.saveUserStatus(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditEmail: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        email: payload.customer_value || ''
      }
      api.saveUserEmail(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    },
    onEditPhone: function(payload) {
      var vm = this
      vm.$store.dispatch('loading')
      var data = {
        pageid: payload.pageid,
        usersid: payload.usersid,
        phoneno: payload.customer_value || ''
      }
      api.saveUserPhoneno(data, function(error, response) {
        if (error) {
          console.error(error)
          vm.$store.dispatch('loading')
        }
        vm.$store.dispatch('loading')
        payload.onEdit()
      })
    }
  },
  watch: {
    value: function() {
      this.user = this.value
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/CustomerItem.vue